<script>
    import HamburgerMenu from "./HamburgerMenu.svelte";

    export let appName;
    export let auth;
    export let firestore;
    export let firebaseApp;
</script>

<nav>
    <div id="left">
        <div class=" mb-3">
            <a href="/" id="title" class=" text-cyan-900 font-bold">
                {appName}🩺
            </a>
        </div>
        <div id="buyme" class="mt-2 mb-2">
            <a
                href="https://www.buymeacoffee.com/vagasinternatoapp"
                class="text-xs font-semibold"
                target="_blank"
            >
                ☕ oferece-nos um café ☕
            </a>
        </div>
    </div>

    <div id="right">
        <HamburgerMenu {auth} {firestore} {firebaseApp} />
    </div>
</nav>

<style>
    nav {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        overflow: hidden;
        position: relative;
    }
    div {
        width: fit-content;
    }

    #title {
        font-size: 30px;
    }

    @media (max-width: 500px) {
        #title {
            font-size: 25px;
        }
    }

    #right {
        align-items: end;
        margin-bottom: 7pt;
        margin-right: 3pt;
    }

    @media (max-width: 320px) {
        nav {
            flex-wrap: wrap;
        }
    }

    #buyme {
        color: rgb(38 38 38);
        background-color: rgb(203 213 225);
        padding-top: 1pt;
        padding-bottom: 3pt;
        padding-left: 2pt;
        padding-right: 2pt;
        border-radius: 0.5rem;
    }
</style>
